import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const MedicalHeartrateReport = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H2V15.3333H14V2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M6.66663 2.00001C6.66663 1.26667 7.26663 0.666672 7.99996 0.666672C8.73329 0.666672 9.33329 1.26667 9.33329 2.00001"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M10 2H6V3.33333H10V2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M2 9.66667H4.2L5.26667 7.86667L7.46667 12L9.33333 6L10.7333 9.66667H14"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>,
  'MedicalHeartrateReport'
);
